"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LineOutline = {
  name: 'line',
  theme: 'outline',
  nameWithTheme: 'line-o',
  tag: 'svg',
  attrs: {
    xmlns: 'http://www.w3.org/2000/svg',
    class: 'icon',
    viewBox: '0 0 1024 1024'
  },
  children: [{
    tag: 'path',
    attrs: {
      d: 'M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'
    },
    children: []
  }]
};
exports.default = LineOutline;